import { motion, useReducedMotion } from "framer-motion";

interface OnboardingWelcomeProps {
  onContinue: () => void;
}

const OnboardingWelcome = ({ onContinue }: OnboardingWelcomeProps) => {
  const reduce = useReducedMotion();

  const fade = (delay = 0) =>
    reduce
      ? { initial: false, animate: { opacity: 1, y: 0 } }
      : {
          initial: { opacity: 0, y: 12 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.6, delay, ease: "easeOut" as const },
        };

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: "#1A1A1A" }}
    >
      <motion.p
        {...fade(0)}
        className="mb-10 font-serif text-2xl text-white/90"
      >
        Dearestly.
      </motion.p>

      <motion.h1
        {...fade(0.15)}
        className="mb-4 max-w-md font-serif text-3xl font-medium leading-snug text-white md:text-4xl"
      >
        The people who matter most deserve to feel it.
      </motion.h1>

      <motion.p
        {...fade(0.4)}
        className="mb-12 max-w-sm text-base leading-relaxed text-white/70"
      >
        You're about to become the person who always shows up.
      </motion.p>

      <motion.button
        {...fade(0.7)}
        onClick={onContinue}
        className="rounded-full px-8 py-3 text-sm font-medium text-[#1A1A1A] transition-transform duration-150 motion-safe:hover:scale-[1.02]"
        style={{ backgroundColor: "#C9A84C" }}
      >
        Let's get you set up →
      </motion.button>

      <motion.p
        {...fade(0.95)}
        className="mt-8 text-xs uppercase tracking-[0.08em] text-white/40"
      >
        Takes less than 2 minutes
      </motion.p>
    </div>
  );
};

export default OnboardingWelcome;
